<script>
import {useUserStore} from "@/store/userStore";

export default {
  name: "ProfileDetailsBlocks",
  setup() {
    const userStore = useUserStore();

    return {
      userStore,
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12 col-md-6 py-3">
      <div class="col-form-label fw-bold">
        {{ $t('profile.firstName') }}:
      </div>
      <div>
        {{ userStore.user.firstName }}
      </div>
    </div>
    <div class="col-12 col-md-6 py-3">
      <div class="col-form-label fw-bold">
        {{ $t('profile.lastName') }}:
      </div>
      <div>
        {{ userStore.user.lastName }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 py-3">
      <div class="col-form-label fw-bold">
        {{ $t('profile.emailAddress') }}:
      </div>
      <div>
        {{ userStore.user.email }}
      </div>
    </div>
    <div class="col-12 col-md-6 py-3">
      <div class="col-form-label fw-bold">
        {{ $t('profile.phoneNumber') }}:
      </div>
      <div>
        {{ userStore.user.telephone }}
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
